/* ENGLA — capa estilo Evolved: buscador overlay + header píldora.
   Auto-contenido. No depende del JS del tema. Revertible. */
(function () {
  'use strict';
  if (window.__evEnhanceLoaded) return; window.__evEnhanceLoaded = true;

  var CLP = function (raw) {
    if (raw == null) return '';
    var s = String(raw);
    if (/[^\d.,\s]/.test(s)) return s;            // ya viene formateado (con $ u otro)
    var n = parseFloat(s.replace(/\./g, '').replace(',', '.'));
    if (!isFinite(n)) return s;
    if (n > 100000 && String(raw).indexOf('.') > -1) n = n; // safety
    return '$' + Math.round(n).toLocaleString('es-CL');
  };

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>';

  function build() {
    var ov = document.createElement('div');
    ov.className = 'ev-search-overlay';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Buscar');
    ov.innerHTML =
      '<div class="ev-search-panel">' +
        '<form class="ev-search-bar" role="search" action="/search" method="get">' +
          ICON +
          '<input class="ev-search-input" name="q" type="search" autocomplete="off" ' +
          'placeholder="Buscar carcasas, cargadores, modelos…" aria-label="Buscar">' +
          '<button type="button" class="ev-search-close" aria-label="Cerrar">&times;</button>' +
        '</form>' +
        '<div class="ev-search-results" aria-live="polite">' +
          '<div class="ev-sr-hint">Escribe para buscar en toda la tienda.</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ov);
    return ov;
  }

  var overlay, input, results, panel, lastFocus, timer, controller;

  function open(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (!overlay) init2();
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var prods = r.products || [], cols = r.collections || [], queries = r.queries || [];
    var html = '';

    if (queries.length) {
      html += '<div class="ev-sr-group-title">Sugerencias</div><div style="padding:2px 6px 6px">';
      queries.slice(0, 6).forEach(function (x) {
        html += '<a class="ev-sr-chip" href="/search?q=' + encodeURIComponent(x.text) + '">' + ICON.replace('viewBox', 'style="width:14px;height:14px" viewBox') + esc(x.text) + '</a>';
      });
      html += '</div>';
    }
    if (cols.length) {
      html += '<div class="ev-sr-group-title">Colecciones</div><div style="padding:2px 6px 6px">';
      cols.slice(0, 5).forEach(function (c) {
        html += '<a class="ev-sr-chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
      });
      html += '</div>';
    }
    if (prods.length) {
      html += '<div class="ev-sr-group-title">Productos</div>';
      prods.slice(0, 6).forEach(function (p) {
        var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || '';
        var price = p.price != null ? p.price : (p.price_min != null ? p.price_min : '');
        html += '<a class="ev-sr-prod" href="' + esc(p.url) + '">' +
          (img ? '<img loading="lazy" src="' + esc(img) + '" alt="">' : '<img alt="">') +
          '<span class="t"><b>' + esc(p.title) + '</b>' + (p.vendor ? '<span>' + esc(p.vendor) + '</span>' : '') + '</span>' +
          '<span class="p">' + esc(CLP(price)) + '</span>' +
        '</a>';
      });
    }
    if (!prods.length && !cols.length && !queries.length) {
      html = '<div class="ev-sr-empty">Sin resultados para “' + esc(q) + '”.</div>';
    } else {
      html += '<a class="ev-sr-all" href="/search?q=' + encodeURIComponent(q) + '">Ver todos los resultados para “' + esc(q) + '” →</a>';
    }
    results.innerHTML = html;
  }

  function query(q) {
    q = q.trim();
    if (q.length < 2) { results.innerHTML = '<div class="ev-sr-hint">Escribe para buscar en toda la tienda.</div>'; return; }
    if (controller && controller.abort) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) { render(q, d); })
      .catch(function () {});
  }

  function bindTriggers() {
    // Cualquier disparador de búsqueda del tema abre NUESTRO overlay.
    var sel = [
      'a[href$="/search"]', 'a[href*="/search?"]',
      '[data-search-toggle]', '.header__icon--search', '.header__search',
      'summary.header__search', 'button[aria-label*="uscar"]', 'a[aria-label*="uscar"]',
      'button[aria-label*="earch"]', 'a[aria-label*="earch"]', '.predictive-search__toggle',
      '.js-search-open', '[href="/search"]'
    ].join(',');
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest(sel) : null;
      if (t) open(e);
    }, true);
  }

  function init2() {
    overlay = build();
    panel = overlay.querySelector('.ev-search-panel');
    input = overlay.querySelector('.ev-search-input');
    results = overlay.querySelector('.ev-search-results');
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.ev-search-close').addEventListener('click', close);
    overlay.querySelector('.ev-search-bar').addEventListener('submit', function (e) {
      var q = input.value.trim(); if (!q) { e.preventDefault(); }
    });
    input.addEventListener('input', function () {
      clearTimeout(timer); var v = input.value;
      timer = setTimeout(function () { query(v); }, 180);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  function headerPill() {
    var h = document.querySelector('.header-wrapper');
    if (!h) return;
    var onScroll = function () {
      document.documentElement.classList.toggle('ev-scrolled', window.scrollY > 8);
    };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  function ready() { init2(); bindTriggers(); headerPill(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
